module.exports = __webpack_public_path__ + "static/media/astra.0af1d122.png";